<template>
  <div class="QuotationEditSuccess" v-title data-title="报价单">
    <template v-if="datas && datas.length > 0">
      <div class="poster-box">

        <div v-if="isWeixin && posterData" class="pt3 pb3 fs8">
          <div class="animation fc-primary font-bold">长按下方图片保存到手机、发送给朋友</div>
        </div>
        <div v-else class="fc-primary font-bold pt3 pb3 fs8">报价单海报已制作完成！</div>
        <van-image
          v-if="posterData"
          width="100%"
          fit="cover"
          :src="posterData"
        >
          <template v-slot:loading>
            图片加载中<van-loading type="spinner" size="20" />
          </template>
        </van-image>
        <div v-else ref="poster-id" class="poster-content">
          <div v-for="(dataItem, dataItemindex) in datas" :key="dataItemindex" class="padding2 ">
            <Quotation @load="loadImage"
              :item="dataItem"
              :queryDateString="queryDateString"
              :pageType="pageType"
              :template="templateType"
            ></Quotation>
          </div>
        </div>
        <!-- 底部按钮区域占位，避免内容被固定按钮遮挡 -->
        <div class="button-placeholder"></div>
      </div>

      <!-- 底部固定按钮容器 -->
      <div class="bottom-button-container">
        <van-button
          v-if="query.from !== 'share'"
          class="btn-back"
          plain
          @click="back"
        >
          返回
        </van-button>
        <van-button
          v-if="!isWeixin"
          class="btn-save"
          type="error"
          @click="createImg"
        >
          保存到相册
        </van-button>
        <van-button
          v-if="isWxMiniProgram"
          class="btn-save"
          type="error"
          @click="sendToMiniProgram"
        >
          保存到相册
        </van-button>
      </div>
    </template>
    <div v-else-if="loading" class="pt10">请稍候,正在生成报价单...</div>
    <!-- <div v-else class="pt10">出错了</div> -->
    <!-- <div class="pt7">
      <van-button class="btn-success" type="primary"
          @click="send">发送给朋友</van-button>
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue';
import html2canvas from 'html2canvas';
import wx from 'weixin-js-sdk';
import Quotation from '../../components/Quotation.vue';
import {
  sendRequest, getPosterShareData, getPosterData, getCommonQuoteData,
} from '../../network/NetworkAccessor';
import { isWeixin, isWxMiniProgram } from '../../uitls/checkUtil';
import storage from '../../uitls/cacheUtil';

export default Vue.extend({
  name: 'QuotationEditSuccess',
  components: { Quotation },
  data() {
    function queryDateString() {
      let date = new Date();
      // 晚上7点(19:00)以后发布的显示明天
      if (date.getHours() >= 19) {
        date = new Date(date.getTime() + 1000 * 60 * 60 * 24);
      }
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${month}月${day}`;
    }
    return {
      info: {},
      datas: [],
      queryDateString: queryDateString(),
      posterData: '',
      isWeixin: isWeixin(),
      isWxMiniProgram: isWxMiniProgram(),
      loading: false,
      loaded: false,
      pageType: 'quotaion',
      LOG_PREFIX: '[QuotationPoster]',
      query: {},
    };
  },
  props: {
    quoteType: {
      type: String,
      default: '1',
    },
    templateType: {
      type: String,
      default: '3',
    },
  },
  created() {
    // 浏览器参数
    const { query } = this.$route;
    this.log('组件初始化', {
      props: {
        quoteType: this.quoteType,
        templateType: this.templateType,
      },
      params: this.$route.params,
      query,
    });
    this.quoteType = query.quoteType || this.quoteType;
    this.templateType = query.templateType || this.templateType;
    let promise = Promise.resolve();
    this.query = query;
    switch (this.$route.name) {
      // web端报价发布页模式
      case 'QuotationPoster':
        this.log('web端报价发布页模式');
        promise = this.getLastData(getPosterData);
        this.pageType = 'quotaion';
        break;
      // web端报价单工具页模式
      case 'QuotationPosterTool':
        this.log('web端报价单工具页模式');
        promise = this.getToolData();
        this.pageType = 'bill';
        break;
      // 小程序webview 报价发布页模式
      case 'QuotationPosterMp':
        this.log('小程序webview 报价发布页模式 获取上次报价');
        promise = this.getLastData(getPosterShareData);
        this.pageType = 'quotaion';
        break;
      // 小程序webview 报价单工具页模式
      case 'QuotationPosterToolMp':
        this.log('小程序webview 报价单工具页模式');
        // 后端存储的通用数据
        promise = this.getCommonQuoteData();
        this.pageType = 'bill';
        break;
      default:
        break;
    }
    promise.then((res) => {
      const resData = res || [];
      this.datas = Array.isArray(resData) ? resData : [resData];
      this.log('数据获取成功', { dataCount: this.datas.length });
      if (!this.datas.length) {
        return Promise.reject(new Error('数据不存在'));
      }
      this.queryDateString = this.datas[0].queryDateText || '';
      this.log('日期字符串设置', { queryDateString: this.queryDateString });
      // 微信环境自动生成海报
      if (isWeixin()) {
        setTimeout(() => {
          this.createImg();
        }, 300);
      }
      return undefined;
    }).catch((e) => {
      this.log('数据获取失败', e, 'error');
      console.error(e);
    });
  },
  methods: {
    // 统一日志输出方法
    log(message, data = null, level = 'log') {
      const prefix = this.LOG_PREFIX;
      const timestamp = new Date().toLocaleTimeString();
      const messageString = `${prefix} [${timestamp}] ${message}`;
      if (data) {
        console[level](messageString, data);
      } else {
        console[level](messageString);
      }
      // alert(`${messageString} ${JSON.stringify(data)}`);
    },
    // 报价单工具页的数据
    getToolData() {
      this.log('getToolData: 开始获取工具页数据');
      const info = storage.session.get('POSTER_DATA');
      if (!info) {
        this.log('getToolData: 未找到缓存数据，跳转到模板页', null, 'warn');
        this.$router.replace('/quotation/template');
        return Promise.resolve().then(() => []);
      }
      this.log('getToolData: 成功获取缓存数据', { hasData: !!info });
      return Promise.resolve().then(() => info);
    },
    // 获取临时传输的报价单数据，主要用于微信小程序和webview页面的数据传输
    async getCommonQuoteData() {
      const { query } = this.$route;
      if (!query.dataId) {
        return Promise.reject(new Error('dataId参数不存在'));
      }
      const res = await sendRequest(getCommonQuoteData, { id: query.dataId });
      console.log('getCommonQuoteData: ', res);
      const data = res.dataJson ? JSON.parse(res.dataJson) : {};
      return data;
    },
    // 获取上次报价信息，主要用于商家报价后跳转的报价单页
    getLastData(api = getPosterData) {
      this.log('getLastData: 开始请求上次报价数据', { quoteType: this.quoteType });
      const { query } = this.$route;
      return sendRequest(api, { ...query, quoteType: this.quoteType }).then((res) => {
        this.log('getLastData: API响应成功', { responseLength: res && res.length });
        return res.map((item) => {
          const quotes = JSON.parse(item.quotes || null) || [];
          let mobileList = [];
          try {
            mobileList = JSON.parse(item.mobile);
            if (Object.prototype.toString.call(mobileList) !== '[object Array]') {
              mobileList = [{
                mobile: item.mobile,
                name: '',
              }];
            }
          } catch (error) {
            this.log('getLastData: 解析手机号列表失败，使用备用格式', error, 'warn');
            console.error(error);
            mobileList = [{
              mobile: item.mobile,
              name: '',
            }];
          }
          return {
            ...item,
            quotes,
            mobileList,
          };
        });
      }).catch((error) => {
        this.log('getLastData: API请求失败', error, 'error');
        throw error;
      });
    },
    send() {
      console.log();
    },
    back() {
      this.log('back: 触发返回操作', {
        route: this.$route.name,
        isWxMiniProgram: isWxMiniProgram(),
        wxAvailable: typeof wx !== 'undefined',
      });

      // 在微信小程序 webview 中，调用小程序的返回
      if (isWxMiniProgram() && typeof wx !== 'undefined') {
        this.log('back: 调用小程序原生返回');
        // eslint-disable-next-line no-undef
        wx.miniProgram.navigateBack({ delta: 1 });
        return;
      }

      // 非小程序环境，使用路由跳转
      if (this.$route.name === 'QuotationPosterTool') {
        this.log('back: 跳转到工具页编辑', { templateType: this.templateType });
        this.$router.replace(`/quotation/posteredit/${this.templateType}`);
      } else {
        this.log('back: 跳转到报价编辑页', { quoteType: this.quoteType });
        this.$router.replace(`/quotation/edit?quoteType=${this.quoteType}`);
      }
    },
    loadImage(flag) {
      this.log('loadImage: 图片加载完成', { flag, isWeixin: this.isWeixin });
      this.loaded = true;
      if (this.isWeixin) {
        this.log('loadImage: 微信环境，自动生成海报');
        this.createImg();
      }
    },
    createImg() {
      setTimeout(() => {
        this.log('createImg: 300ms后开始生成海报图片');
        this.doCreateImg();
      }, 300);
    },
    doCreateImg() {
      this.log('doCreateImg: 开始生成海报图片');
      this.$nextTick().then(() => {
        // const windowWidth = window.document.body.scrollWidth;
        // const windowHeight = window.document.body.scrollHeight;
        // const windowScreenWidth = window.screen.width;
        const html2canvasOptions = {
          allowTaint: true,
          useCORS: false,
          scrollX: 0,
          scrollY: 0,
          // windowWidth,
          // windowHeight,
          dpi: window.devicePixelRatio * 2, // 解决图片不清晰问题
          scale: 2,
        };
        this.log('createImg: html2canvas配置', html2canvasOptions);
        // if (windowScreenWidth > windowWidth) {
        //   delete html2canvasOptions.windowWidth;
        //   delete html2canvasOptions.windowHeight;
        // }
        // console.log('html2canvasOptions: ', html2canvasOptions);
        html2canvas(this.$refs['poster-id'], html2canvasOptions).then((canvas) => {
          this.log('createImg: html2canvas生成成功', {
            width: canvas.width,
            height: canvas.height,
          });
          if (this.isWeixin) {
            this.log('createImg: 微信环境，生成base64图片');
            const dataUrl = canvas.toDataURL();
            this.posterData = dataUrl;
            this.log('createImg: 图片数据已设置，长度', dataUrl.length);
            return;
          }
          const { userAgent } = navigator;
          this.log('createImg: 用户代理', { userAgent });
          // 判断是否是IE11
          if (userAgent.indexOf('Trident') !== -1) {
            this.log('createImg: 检测到IE11浏览器');
            const image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
            const arr = image.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n) {
              n -= 1;
              u8arr[n] = bstr.charCodeAt(n);
            }
            window.navigator.msSaveBlob(new Blob([u8arr], { type: mime }), `报价单海报_${this.queryDateString}.png`);
            this.log('createImg: IE11保存完成', { fileName: `报价单海报_${this.queryDateString}.png` });
          } else {
            // 生成base64图片数据
            const dataUrl = canvas.toDataURL();
            this.log('createImg: 生成base64图片数据', { dataLength: dataUrl.length });
            this.log('createImg: 普通浏览器环境，触发下载');
            // this.posterData = dataUrl;
            const newImg = document.createElement('img');
            newImg.src = dataUrl;
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = dataUrl;
            // 获取文件名
            // download 属性定义了下载链接的地址而不是跳转路径
            const fileName = `报价单海报_${this.queryDateString}.png`;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.log('createImg: 下载完成', { fileName });
          }
        }).catch((e) => {
          this.log('createImg: html2canvas失败', e, 'error');
          console.error(e);
        });
      });
    },
    sendToMiniProgram() {
      // alert('sendToMiniProgram');
      this.log('sendToMiniProgram: 小程序环境，发送数据回小程序');
      // 发送图片数据回小程序
      // eslint-disable-next-line no-undef
      wx.miniProgram.postMessage({
        data: {
          type: 'IMAGE_GENERATED',
          imageData: this.posterData,
          fileName: `报价单海报_${this.query.queryDate}.png`,
        },
      });
      // eslint-disable-next-line no-undef
      wx.miniProgram.navigateBack({ url: '' });
    },
  },
});
</script>
<style scoped>
.QuotationEditSuccess {
  min-height: 100vh;
}
.btn-success {
  width: 60%;
}
.poster-box {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100vh;
  padding: 0;
}
.poster-content {
  position: relative;
  border-radius: 16px;
  padding: 10px;
  /* 荧光红 */
  background: #ff4444;
  /* 发光效果 */
  /* box-shadow:
    0 0 20px rgba(102, 126, 234, 0.5),
    0 0 40px rgba(118, 75, 162, 0.3),
    0 8px 32px rgba(0, 0, 0, 0.15); */
  /* 可选：添加旋转动画，取消注释即可 */
  /* animation: borderRotate 3s linear infinite; */
}

/* 内层白色背景 */
.poster-content::before {
  content: '';
  position: absolute;
  top: 10px;
  right: 10px;
  bottom: 10px;
  left: 10px;
  background: white;
  border-radius: 12px;
  z-index: 0;
}

/* 确保内容在白色背景之上 */
.poster-content > * {
  position: relative;
  z-index: 1;
}

/* 旋转渐变动画（可选） */
@keyframes borderRotate {
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}
.QuotationEditSuccess .animation {
  animation: dd 5s .15s linear infinite;
}
@keyframes dd {
  0%,
  100% {
  -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
  -webkit-transform-origin: 50% 0;
          transform-origin: 50% 0;
  }
  5% {
  -webkit-transform: rotate(2deg);
          transform: rotate(2deg);
  }
  10%,
  20%,
  30% {
  -webkit-transform: rotate(-4deg);
          transform: rotate(-4deg);
  }
  15%,
  25%,
  35% {
  -webkit-transform: rotate(4deg);
          transform: rotate(4deg);
  }
  40% {
  -webkit-transform: rotate(-2deg);
          transform: rotate(-2deg);
  }
  45% {
  -webkit-transform: rotate(2deg);
          transform: rotate(2deg);
  }
  50% {
  -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
  }
}

/* 底部按钮占位 */
.button-placeholder {
  height: 100px;
}

/* 底部固定按钮容器 */
.bottom-button-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 12px 24px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  background-color: #ffffff;
  border-top: 3px solid #e0e0e0;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
  z-index: 999;
}

/* 返回按钮样式 */
.bottom-button-container .btn-back {
  width: 150px;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;
  color: #616161;
  border: 3px solid #bdbdbd;
  background-color: #ffffff;
}

/* 保存按钮样式 */
.bottom-button-container .btn-save {
  width: 200px;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;
  background-color: #d32f2f;
  color: #ffffff;
  border: none;
}

/* 按钮点击效果 */
.bottom-button-container .van-button:active {
  opacity: 0.8;
  transform: scale(0.98);
  transition: all 0.2s;
}
</style>
